import { addCommasToNumberString } from "components/monetary-input/definitions";
import { Assessment, Payment, Task } from "models/schemas";

export interface IAuditOverviewProps {}

export interface GetAuditByIdRequest {
  auditId: string;
  teamName?: string;
}

export interface GetAuditByShortIdRequest {
  shortId: string;
}

export interface ListAssessmentRequest {
  gaiaObjectId: string;
}

export interface ListAssessmentResponse {
  assessments: {
    assessments: Assessment[];
  };
}

export interface ListPaymentRequest {
  gaiaObjectId: string;
}

export interface ListPaymentResponse {
  payments: {
    payments: Payment[];
  };
}

export interface DeleteAssessmentRequest {
  assessmentId: string;
  gaiaObjectId: string;
}

export interface DeleteAssessmentResponse {}

export interface DeletePaymentRequest {
  paymentId: string;
  gaiaObjectId: string;
}

export interface DeletePaymentResponse {}

export function formatMonetaryValue(num: number, currencySign: string): string {
  num = Math.round(num * 100) / 100;
  const base = addCommasToNumberString(String(num));
  if (!base.includes(".")) {
    return currencySign + base + ".00";
  } else if (base.split(".")[1].length === 1) {
    return currencySign + base + "0";
  }
  return currencySign + base;
}
